<app-header></app-header>
<!-- Start of Desktop Content -->
<ion-content
  *ngIf="(platformService?.isTouchExperience$ | async) === false"
  class="gray-content-bg"
  scroll-y="false"
>
  <ion-grid [class.hide]="!isLoading" [fixed]="true">
    <app-list-skeleton></app-list-skeleton>
  </ion-grid>
  <div [class.hide]="isLoading" id="desktop">
    <cdk-virtual-scroll-viewport
      id="list-scroll-{{viewModel?.list?.listId}}"
      data-cy="list-detail-desktop-scroll"
      class="cdk-scroll"
      orientation="vertical"
      appCustomVs
      [itemHeights]="viewModel?.itemHeights"
      [indexOffset]="2"
      [items]="viewModel?.items"
      [listId]="viewModel?.list?.listId"
    >
      <ion-grid [fixed]="true">
        <!-- Breadcrumbs -->
        <ion-row class="breadcrumbs-section">
          <ion-col size="8">
            <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
          </ion-col>
          <ion-col *ngIf="viewModel?.list?.primaryCount > 0" size="4">
            <ion-row class="interact-download">
              <ion-label (click)="openDownloadPrintModal(false)">
                <ion-icon name="print-outline"></ion-icon>
                {{ 'i18n.common.print' | translate }}
              </ion-label>
              <ion-label (click)="openDownloadPrintModal(true)">
                <ion-icon name="download-outline"></ion-icon>
                {{ 'i18n.common.download' | translate }}
              </ion-label>
            </ion-row>
          </ion-col>
        </ion-row>
        <!-- List Banner -->
        <app-list-banner
          [listName]="viewModel?.list?.listName"
          [listItemCount]="viewModel?.list?.primaryCount"
          [showEllipsis]="viewModel?.showEllipsis || (copyListEnabled && viewModel?.items?.length > 0)"
          (ellipsisClickEventEmitter)="openListOptions($event)"
        ></app-list-banner>
        <!-- Search, Sort & Filter -->
        <ion-row
          class="ion-margin-top"
          [class.hide]="viewModel?.list?.primaryCount === 0"
        >
          <ion-col
            size-xl="9"
            size-lg="9"
            size-md="9"
            size-sm="12"
            size-xs="12"
          >
            <ng-container [ngTemplateOutlet]="searchSortFilter"></ng-container>
          </ion-col>
        </ion-row>

        <ion-row class="main-content">
          <!-- No Results -->
          <ion-col
            [class.hide]="viewModel?.items?.length !== 0"
            size-xl="9"
            size-lg="8"
            size-md="8"
            size-sm="9"
            size-xs="9"
          >
            <app-no-products-in-group
              [listCount]="viewModel?.list?.primaryCount"
              [itemsLeftAfterFilter]="viewModel?.items?.length"
              [isEditableList]="false"
              [isMobile]="false"
              [isListManagement]="false"
            ></app-no-products-in-group>
          </ion-col>
          <!-- Group and Product Rows -->
          <ion-col
            [class.hide]="viewModel?.items?.length === 0"
            size-xl="9"
            size-lg="8"
            size-md="8"
            size-sm="9"
            size-xs="9"
          >
            <app-group-product-list-desktop
              [items]="viewModel?.items"
              [mode]="mode"
              [pricingDisabled]="viewModel?.selectedCustomer?.ogPrintPriceInd === 'N'"
              [isOnline]="(panAppState.online$ | async)"
              [showNotes]="false"
              [listItemNoteFeatureFlag]="false"
              (ellipsisEmitter)="openProductCardEllipsis($event)"
              (infoIconClickEmitter)="openProductStatus($event)"
              (itemNoteClickEmitter)="openItemNoteModal($event)"
              (productCardClickEmitter)="routeToPDP($event)"
              (promotionClickEmitter)="clickPromotions($event)"
              (quantityInputEmitter)="quantityFocusHandler($event)"
              (quantityUpdateEmitter)="changeQuantityHandler($event)"
              (collapseAlternatesEmitter)="collapseAlternates($event)"
              (betterBuyDeclineEmitter)="handleBetterBuyDeclineClick($event)"
              (acceptSwapEmitter)="acceptSwap($event)"
              (selectProductCardEmitter)="handleProductSelection($event)"
              (productConversionEmitter)="productConversionEmitter($event)"
            >
            </app-group-product-list-desktop>
          </ion-col>
          <ion-col size-xl="3" size-lg="4" size-md="4" size-sm="3" size-xs="3">
            <app-order-info-sidebar
              [platform]="platformService?.platformType"
              [orderHeader]="viewModel?.orderHeader"
              [orderItemTallies]="viewModel?.orderItemTallies"
              [isList]="true"
              [isCart]="false"
              [isOnMinimumOrderMetFlag]="viewModel?.orderMinimumMetFeatureFlag"
              [showPrintIcon]="false"
            >
            </app-order-info-sidebar>
          </ion-col>
        </ion-row>
      </ion-grid>
      <div id="footer">
        <app-footer></app-footer>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</ion-content>

<!-- Start of Tablet Content -->
<ion-content
  *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
  class="gray-content-bg"
  scroll-y="false"
>
  <ion-grid [class.hide]="!isLoading" [fixed]="true">
    <app-list-skeleton></app-list-skeleton>
  </ion-grid>
  <cdk-virtual-scroll-viewport
    [class.hide]="isLoading"
    id="list-scroll-{{viewModel?.list?.listId}}"
    data-cy="list-detail-tablet-scroll"
    class="cdk-scroll"
    orientation="vertical"
    appCustomVs
    [itemHeights]="viewModel?.itemHeights"
    [indexOffset]="2"
    [items]="viewModel?.items"
    [listId]="viewModel?.list?.listId"
  >
    <!-- List Banner -->
    <app-list-banner
      [listName]="viewModel?.list?.listName"
      [listItemCount]="viewModel?.list?.primaryCount"
      [showEllipsis]="viewModel?.showEllipsis || (copyListEnabled && viewModel?.items?.length > 0)"
      (ellipsisClickEventEmitter)="openListOptions($event)"
      (downloadClickEventEmitter)="openDownloadPrintModal(true)"
      (printClickEventEmitter)="openDownloadPrintModal(false)"
    ></app-list-banner>

    <ion-grid [fixed]="true">
      <!-- Search, Sort & Filter -->
      <ion-row
        class="ion-margin-top"
        [class.hide]="viewModel?.list?.primaryCount === 0"
      >
        <ion-col size-xl="9" size-lg="9" size-md="8" size-sm="8" size-xs="8">
          <ng-container [ngTemplateOutlet]="searchSortFilter"></ng-container>
        </ion-col>
      </ion-row>
      <!-- Main Content-->
      <ion-row>
        <!-- No Results -->
        <ion-col
          [class.hide]="viewModel?.items?.length !== 0"
          size-xl="9"
          size-lg="8"
          size-md="8"
          size-sm="7"
          size-xs="9"
        >
          <app-no-products-in-group
            [listCount]="viewModel?.list?.primaryCount"
            [itemsLeftAfterFilter]="viewModel?.items?.length"
            [isEditableList]="false"
            [isMobile]="false"
            [isListManagement]="false"
          ></app-no-products-in-group>
        </ion-col>

        <!-- List of groups and products -->
        <ion-col
          [class.hide]="viewModel?.items?.length === 0"
          size-xl="9"
          size-lg="8"
          size-md="8"
          size-sm="7"
          size-xs="9"
        >
          <app-group-product-list-touch
            [items]="viewModel?.items"
            [mode]="mode"
            [pricingDisabled]="viewModel?.selectedCustomer?.ogPrintPriceInd === 'N'"
            [isOnline]="(panAppState.online$ | async)"
            [isMobile]="false"
            [showNotes]="false"
            (ellipsisEmitter)="openProductCardEllipsis($event)"
            (infoIconClickEmitter)="openProductStatus($event)"
            (itemNoteClickEmitter)="openItemNoteModal($event)"
            (productCardClickEmitter)="routeToPDP($event)"
            (promotionClickEmitter)="clickPromotions($event)"
            (quantityInputEmitter)="quantityFocusHandler($event)"
            (quantityUpdateEmitter)="changeQuantityHandler($event)"
            (collapseAlternatesEmitter)="collapseAlternates($event)"
            (betterBuyDeclineEmitter)="handleBetterBuyDeclineClick($event)"
            (acceptSwapEmitter)="acceptSwap($event)"
            (selectProductCardEmitter)="handleProductSelection($event)"
            (productConversionEmitter)="productConversionEmitter($event)"
          >
          </app-group-product-list-touch>
        </ion-col>
        <ion-col
          size-xl="3"
          size-lg="3"
          size-md="3"
          push-md="1"
          size-sm="3"
          size-xs="3"
        >
          <app-order-info-sidebar
            [platform]="platformService?.platformType"
            [orderHeader]="viewModel?.orderHeader"
            [orderItemTallies]="viewModel?.orderItemTallies"
            [isList]="true"
            [isCart]="false"
            [isOnMinimumOrderMetFlag]="viewModel?.orderMinimumMetFeatureFlag"
            [showPrintIcon]="false"
          ></app-order-info-sidebar>
        </ion-col>
      </ion-row>
    </ion-grid>
  </cdk-virtual-scroll-viewport>
</ion-content>

<!-- Start of Mobile Content -->
<ion-content
  *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
  id="mobile"
  class="gray-content-bg"
  scroll-y="false"
>
  <cdk-virtual-scroll-viewport
    id="mobile-scroll"
    data-cy="list-detail-mobile-scroll"
    class="cdk-scroll"
    orientation="vertical"
    appCustomVs
    [itemHeights]="viewModel?.itemHeights"
    [indexOffset]="2"
    [items]="viewModel?.items"
    [listId]="viewModel?.list?.listId"
  >
    <app-list-skeleton [class.hide]="!isLoading"></app-list-skeleton>

    <ion-grid [fixed]="true" [class.hide]="isLoading">
      <!-- List Banner -->
      <app-list-banner
        [listName]="viewModel?.list?.listName"
        [listItemCount]="viewModel?.list?.primaryCount"
        [showEllipsis]="viewModel?.showEllipsis || (copyListEnabled && viewModel?.items?.length > 0)"
        (ellipsisClickEventEmitter)="openListOptions($event)"
      ></app-list-banner>
      <!-- Search, Sort & Filter -->
      <ion-row
        class="ion-margin-top"
        [class.hide]="viewModel?.list?.primaryCount === 0"
      >
        <ion-col size="12">
          <ng-container [ngTemplateOutlet]="searchSortFilter"></ng-container>
        </ion-col>
      </ion-row>
      <!-- List of groups and products -->
      <app-group-product-list-touch
        [items]="viewModel?.items"
        [mode]="mode"
        [pricingDisabled]="viewModel?.selectedCustomer?.ogPrintPriceInd === 'N'"
        [isOnline]="(panAppState.online$ | async)"
        [isMobile]="true"
        [showNotes]="false"
        (ellipsisEmitter)="openProductCardEllipsis($event)"
        (infoIconClickEmitter)="openProductStatus($event)"
        (itemNoteClickEmitter)="openItemNoteModal($event)"
        (productCardClickEmitter)="routeToPDP($event)"
        (promotionClickEmitter)="clickPromotions($event)"
        (quantityInputEmitter)="quantityFocusHandler($event)"
        (quantityUpdateEmitter)="changeQuantityHandler($event)"
        (collapseAlternatesEmitter)="collapseAlternates($event)"
        (betterBuyDeclineEmitter)="handleBetterBuyDeclineClick($event)"
        (acceptSwapEmitter)="acceptSwap($event)"
        (selectProductCardEmitter)="handleProductSelection($event)"
        (productConversionEmitter)="productConversionEmitter($event)"
      >
      </app-group-product-list-touch>
      <!-- No Results -->
      <ion-row *ngIf="viewModel?.items?.length === 0">
        <ion-col size="12">
          <app-no-products-in-group
            [listCount]="viewModel?.list?.primaryCount"
            [itemsLeftAfterFilter]="viewModel?.items?.length"
            [isEditableList]="false"
            [isMobile]="true"
            [isListManagement]="false"
          ></app-no-products-in-group>
        </ion-col>
      </ion-row>
    </ion-grid>
  </cdk-virtual-scroll-viewport>
</ion-content>

<div
  [class.static-buttons]="platformService.platformType === platformService.platformEnum.mobile && showTopButton"
  [class.has-selected-products]="viewModel?.selectedProducts?.size > 0"
  data-cy="list-detail-static-buttons-section"
>
  <div
    *ngIf="platformService.platformType === platformService.platformEnum.mobile && viewModel?.orderItemTallies?.totalItems > 0"
    data-cy="list-detail-review-order-button-section"
    class="review-order-mobile"
  >
    <ion-button
      data-cy="list-detail-review-order-button"
      class="usf-fill-green-mobile-modal-button"
      (click)="routeTo('/order')"
    >
      {{ 'i18n.lists.reviewOrder' | translate }}
    </ion-button>
  </div>
  <div
    *ngIf="showTopButton"
    data-cy="list-detail-top-button-section"
    class="top-button"
  >
    <ion-button
      data-cy="list-detail-top-button"
      class="usf-fill-green-button"
      (click)="goToTop()"
    >
      {{ 'i18n.common.top' | translate }}&nbsp;
      <ion-icon
        data-cy="list-detail-top-button-icon"
        name="chevron-up-circle-outline"
      ></ion-icon>
    </ion-button>
  </div>
</div>

<!-- COMPARE PRODUCTS STICKY FOOTER -->
<section class="sticky-action-bar" *ngIf="viewModel?.selectedProducts?.size">
  <a
    class="compare-action"
    data-cy="master-list-compare-products-cancel-text"
    (click)="resetAlternateComparison()"
  >
    {{ 'i18n.common.cancel' | translate }}
  </a>
  <div class="grouped-actions">
    <ion-button
      data-cy="master-list-compare-products-button"
      class="usf-outline-green-button"
      [class.compare-button-disabled]="viewModel?.selectedProducts?.size < 2"
      [disabled]="viewModel?.selectedProducts?.size < 2"
      (click)="compareSelectedProducts()"
    >
      {{ 'i18n.common.compare' | translate }}
      {{viewModel?.selectedProducts.size}}/{{maxSelectableProductsForComparison}}
    </ion-button>
    <a
      *ngIf="
        viewModel?.selectedProducts?.size >= 3 ||
        (
          viewModel?.selectedProducts?.size === 2 &&
          !viewModel?.isDivisionSubSelected
        )
      "
      class="compare-action"
      data-cy="master-list-compare-products-clear-all-text"
      (click)="clearSelectedNonPrimaryProducts()"
    >
      {{ 'i18n.common.clearAll' | translate }}
    </a>
  </div>
</section>

<!-- SEARCH, SORT & FILTER TEMPLATE -->
<ng-template #searchSortFilter>
  <div
    data-cy="list-detail-search-sort-filter-section"
    class="search-sort-filter-section"
  >
    <div class="search-container">
      <ion-searchbar
        id="list-search-bar-{{viewModel?.list?.listId}}-0"
        data-cy="list-detail-searchbar"
        class="search"
        globalkeyhandler="filterBar"
        mode="md"
        placeholder="{{ 'i18n.lists.searchWithinYourList' | translate }}"
        [(ngModel)]="searchKey"
        (ionInput)="search()"
        (ionClear)="resetSearch()"
        (search)="search()"
      >
      </ion-searchbar>
    </div>
    <app-sort-and-filter-button
      [sortAndFilterCount]="viewModel?.sortAndFilterCount"
      (openSortAndFilterListModalEmitter)="handleOpenSortAndFilterListModal($event)"
      (clearSortAndFilterListModalEmitter)="handleClearSortAndFilterListModalEmitter($event)"
    ></app-sort-and-filter-button>
  </div>
</ng-template>

<!-- Download List Modal -->
<app-list-download-container
  [translateService]="translateService"
  (submitEvent)="downloadList($event)"
></app-list-download-container>

<!-- Print List Modal -->
<app-list-print-container
  [translateService]="translateService"
  (submitEvent)="downloadList($event)"
></app-list-print-container>

<!-- Download list modal-->
<ion-modal
  [isOpen]="listsOverlayService?.listDownloadModalOptions$?.value?.isOpen"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
  (ionModalDidDismiss)="closeDownloadListModal()"
  [ngClass]="platformService.platformType !== platformService.platformEnum.desktop ? 'ion-modal-touch' : (listsOverlayService?.listDownloadModalOptions$?.value?.isDownload ? 'modal-desktop-size-lg' : 'download-print-desktop')"
>
  <ng-template>
    <app-download-list-v2
      class="ion-page"
      [platformType]="platformService?.platformType"
      [listName]="listsOverlayService?.listDownloadModalOptions$?.value?.listName"
      [listId]="listsOverlayService?.listDownloadModalOptions$?.value?.listId"
      [listTypeId]="listsOverlayService?.listDownloadModalOptions$?.value?.listTypeId"
      [isDownload]="listsOverlayService?.listDownloadModalOptions$?.value?.isDownload"
      [hidePricingOption]="viewModel?.selectedCustomer?.ogPrintPriceInd === 'N'"
      (dismissEvent)="closeDownloadListModal()"
      (downloadEmitter)="downloadList($event)"
    >
    </app-download-list-v2>
  </ng-template>
</ion-modal>
